import React, { Fragment, useEffect, useState } from 'react';
import { useStateSelector } from '../../../../store/selectors';
import createNotification from '../../../../utils/createNotification';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { MyAccountMenuItem } from '../items/MyAccountMenuItem';
import { paths } from '../../../../routing/path';

export const AdminMenu = () => {
    const axios = useStateSelector((state) => state.core.axios);
    const [approvalLabel, setApprovalLabel] = useState('Approval Queues');
    const [standardizationLabel, setStandardizationLabel] =
        useState('Standardizations');
    const [supportLabel, setSupportLabel] = useState('Support Requests');

    useEffect(() => {
        axios
            .get('/api/PendingAdminRequests')
            .then((response: any) => {
                if (response.data) {
                    if (!response.data.isError) {
                        setApprovalLabel(
                            `Approval Queues - ${response.data.data}`
                        );
                    } else {
                        createNotification(response.data.message, 'error');
                    }
                } else {
                    createNotification(response.response.data.message, 'error');
                }
            })
            .catch((error: any) =>
                createNotification(error.message, 'error')
            );

        axios
            .get('api/StandardizationPurchases/activeCount')
            .then((response: any) => {
                if (response?.status === 200) {
                    if (response.data !== 0) {
                        setStandardizationLabel(
                            `Standardizations - ${response.data}`
                        );
                    }
                } else {
                    createNotification(
                        'Active Standardizations Count Fetching Error',
                        'error'
                    );
                }
            })
            .catch((error: any) =>
                createNotification(error.message, 'error')
            );

        axios
            .get('api/SupportRequests/SupportThreads/openedCount')
            .then((response: any) => {
                if (response?.status === 200) {
                    setSupportLabel(
                        response.data > 0
                            ? `Support Requests - ${response.data}`
                            : 'Support Requests'
                    );
                }
            })
            .catch((error: any) =>
                createNotification(error.message, 'error')
            );
    }, [axios]);

    return (
        <Fragment>
            <LeftMenuItem
                icon="pe-7s-display2"
                label={approvalLabel}
                to={paths.account.dashboard}
                trackingAction="Approval Queues"
            />
            <LeftMenuItem
                icon="pe-7s-refresh-2"
                label={standardizationLabel}
                to={paths.account.standardizationServices}
                trackingAction="Standardization Sevices"
            />
            <LeftMenuItem
                icon="pe-7s-chat"
                label={supportLabel}
                to={paths.admin.supportRequests}
                trackingAction="Support Requests"
                gtmCategory="Support Requests"
            />
            <LeftMenuItem
                icon="pe-7s-display2"
                label="Nonprofit Management"
                to={paths.account.charityApproval}
                trackingAction="charity approval"
            />
            <LeftMenuItem
                icon="pe-7s-add-user"
                label="Member List"
                to={paths.account.associates}
                trackingAction="My Team Members"
                gtmCategory="My Account"
            />
            <LeftMenuItem
                icon="pe-7s-albums"
                label="Practice List"
                to={paths.admin.practiceList}
                trackingAction="Practice List"
                gtmCategory="Practice List"
            />
            <LeftMenuItem
                icon="pe-7s-edit"
                label="Automated Services Inputs"
                to={paths.admin.controls}
                trackingAction="Automated Services Inputs"
            />
            <LeftMenuItem
                icon="pe-7s-cash"
                label="Pricing, Discounts, Rebates, and Referral Fees"
                to={paths.admin.pricing}
                trackingAction="Product Pricing & Discounts"
            />
            <LeftMenuItem
                icon="pe-7s-graph2"
                label="Valuation Report Input Forms"
                to={paths.admin.paidReportFromUpdates}
                trackingAction="Valuation Report Input Forms"
            />
            <LeftMenuItem
                icon="pe-7s-mail-open-file"
                label="Public F&E Requests"
                to={paths.admin.publicFeRequests}
                trackingAction="Public FE Requests"
            />
            <LeftMenuItem
                icon="pe-7s-bell"
                label="Subscriptions"
                to={paths.account.subscriptions}
                trackingAction="Subscriptions"
            />
            <LeftMenuItem
                icon="pe-7s-bell"
                label="Upload Chart"
                to={paths.admin.uploadChart}
                trackingAction="UploadChart"
            />
            <LeftMenuItem
                icon="pe-7s-users"
                label="Practice Management Groups"
                to={paths.admin.pmgAdmin}
                trackingAction="PMGAdmin"
            />
            <LeftMenuItem
                icon="pe-7s-portfolio"
                label="Corporate Group Management"
                to={paths.admin.cgmAdmin}
                trackingAction="CGMAdmin"
            />
            <LeftMenuItem
                icon="pe-7s-speaker"
                label="Announcements Manager"
                to={paths.account.announcements}
                trackingAction="Announcements Manager"
                gtmCategory="Announcements Manager"
            />
            <LeftMenuItem
                icon="pe-7s-note2"
                label="Knowledge Library Content Manager"
                to={paths.admin.knowledgeLibrary}
                trackingAction="Knowledge Library Content Manager"
                gtmCategory="Knowledge Library Content Manager"
            />
            <MyAccountMenuItem withFlag={false} />
            <LeftMenuItem
                icon="pe-7s-news-paper"
                label="Audit Logs"
                to={paths.account.auditLogs}
                trackingAction="Audit Logs"
            />
            <LeftMenuItem
                icon="pe-7s-bell"
                label="Notifications"
                to={paths.admin.notifications}
                trackingAction="Notifications"
                gtmCategory="Audit Logs"
            />
            <LeftMenuItem
                icon="pe-7s-share"
                label="Data & Docs Requests"
                to={paths.admin.dataAndDocumentRequests}                trackingAction="Data And Document Requests"
                gtmCategory="Data And Document Requests"
            />
            <LeftMenuItem
                icon="pe-7s-share"
                label="Data & Docs Templates"
                to={paths.admin.dataAndDocumentTemplates}                trackingAction="Data And Document Templates"
                gtmCategory="Data And Document Templates"
            />
            <LeftMenuItem
                icon="pe-7s-plugin"
                label="Marketplace Admin"
                to={paths.admin.marketplace}
                flagCode={NotificationFlagsCategories.MpCode}
                stateIcon="pe-7s-plugin"
                trackingAction="MarketplaceAdmin"
                gtmCategory="Marketplace Admin"
            />
            <LeftMenuItem
                icon="pe-7s-plugin"
                label="Landscape Map Demo"
                to={`${paths.admin.landscapeMap}?practicesCount=25`}                stateIcon="pe-7s-plugin"
                trackingAction="MarketplaceAdmin"
                gtmCategory="Marketplace Admin"
            />
            <LeftMenuItem
                icon="pe-7s-note2"
                label="Legal Documents"
                to={paths.admin.legalDocuments}                trackingAction="LegalDocuments"
                gtmCategory="Legal Documents"
            />
        </Fragment>
    );
};
